import { render, staticRenderFns } from "./list.vue?vue&type=template&id=0c6323da"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=0c6323da&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6323da')) {
      api.createRecord('0c6323da', component.options)
    } else {
      api.reload('0c6323da', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=0c6323da", function () {
      api.rerender('0c6323da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/supplyCentreSyntheticalManagement/supplyCentreList/list.vue"
export default component.exports